import { observer } from 'mobx-react-lite';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { AnimationElementSelectionDetail } from './components/AnimationElementSelectionDetail';
export const PlayAnimationActionDetails = observer(({
  action
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(AnimationElementSelectionDetail, {
    name: t("action_editor.property_animation_element"),
    selectedAnimationElement: action.animationElement,
    animationElementSetter: action.setAnimationElement.bind(action)
  }));
});